/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ListingFields
 */
export interface ListingFields {
  /**
   *
   * @type {string}
   * @memberof ListingFields
   */
  headerListing: string | null
  /**
   *
   * @type {string}
   * @memberof ListingFields
   */
  titleTagListing: string | null
  /**
   *
   * @type {string}
   * @memberof ListingFields
   */
  descriptionTagListing: string | null
}

/**
 * Check if a given object implements the ListingFields interface.
 */
export function instanceOfListingFields(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'headerListing' in value
  isInstance = isInstance && 'titleTagListing' in value
  isInstance = isInstance && 'descriptionTagListing' in value

  return isInstance
}

export function ListingFieldsFromJSON(json: any): ListingFields {
  return ListingFieldsFromJSONTyped(json, false)
}

export function ListingFieldsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ListingFields {
  if (json === undefined || json === null) {
    return json
  }
  return {
    headerListing: json['headerListing'],
    titleTagListing: json['titleTagListing'],
    descriptionTagListing: json['descriptionTagListing'],
  }
}

export function ListingFieldsToJSON(value?: ListingFields | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    headerListing: value.headerListing,
    titleTagListing: value.titleTagListing,
    descriptionTagListing: value.descriptionTagListing,
  }
}
